/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2025 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import URLs from '../utilities/URLs';

export async function getAntiforgeryToken() {
  const response = await fetch(URLs.getAntiforgeryToken(), {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }
}
